export default __webpack_public_path__ + "static/media/edge.3c9d9c62.svg";